import { render, staticRenderFns } from "./view-credit-note.vue?vue&type=template&id=624ca706&scoped=true"
import script from "./view-credit-note.vue?vue&type=script&lang=js"
export * from "./view-credit-note.vue?vue&type=script&lang=js"
import style0 from "./view-credit-note.vue?vue&type=style&index=0&id=624ca706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ca706",
  null
  
)

export default component.exports